// extracted by mini-css-extract-plugin
export default {"LazyLoadingFallback":"LazyLoadingFallback_LazyLoadingFallback__x3z6S","Loading":"LazyLoadingFallback_Loading__Sroi5","Text":"LazyLoadingFallback_Text__jAt3W"};